// 1×1 transparent GIF as an inline data URL.
//
// Replaces a previous file-based import of `blank.gif`, which was blocked by
// most adblock/tracker filter lists (the literal filename `blank.gif` is on
// every common blocklist as it's the canonical tracking-pixel name). Inlining
// avoids the network request entirely so it works regardless of extensions.
//
// Used as the `src` of <img> elements rendered behind the country-flag CSS
// sprite background — the image itself is invisible; the actual flag is set
// via a `background-image` rule keyed off the `.flag-xx` class.
export const BLANK_PIXEL_DATA_URL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
